export const isTruthy = (x) => !!x;
//# sourceMappingURL=types.js.map